function MiniStatistics(props: {
    name: string;
    values?: string;
    icon: JSX.Element;
    value: string;
    iconBg: string;
    extra?: string;
}) {
    const { name, value, extra } = props;
    return (
        <div
            className={`flex w-full border items-center gap-[5px] rounded bg-clip-border px-[5px] sm:px-[18px] py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none ${extra}`}
        >
            <div className="ml-5">
                <p className=" mb-1 text-sm font-medium text-gray-600">
                    {name}
                </p>
                <h3 className="text-md sm:text-xl font-bold leading-6 text-navy-700 dark:text-white">
                    {value}
                </h3>
            </div>
        </div>
    );
}

export default MiniStatistics;
